import React from 'react';
import { Star } from 'lucide-react';

const TestimonialCard = ({ testimonial }) => {
  return (
    <div className="bg-card rounded-xl border border-border shadow-therapeutic p-6 hover:shadow-therapeutic-md transition-all">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
          <span className="text-lg font-bold text-primary">{testimonial?.avatar}</span>
        </div>
        <div>
          <p className="font-semibold text-foreground">{testimonial?.name}</p>
          <p className="text-xs text-muted-foreground">{testimonial?.role}</p>
        </div>
      </div>

      <div className="flex gap-1 mb-3">
        {[...Array(testimonial?.rating)]?.map((_, i) => (
          <Star key={i} className="w-4 h-4 fill-warning text-warning" />
        ))}
      </div>

      <p className="text-sm text-foreground leading-relaxed">
        "{testimonial?.text}"
      </p>
    </div>
  );
};

export default TestimonialCard;